import * as React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";
import Compressor from "compressorjs";
import {
  Grid,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardMedia,
  TextField,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  IconButton,
  Checkbox,
  Typography,
  Autocomplete,
  Icon,
  Stack,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

export const Difusion = (props) => {
  const {
    fullScreen,
    open,
    row,
    handleCloseEdit,
    opcionGrupos,
    handleAceptEdit,
    theme,
  } = props;
  const [titulo, setTitulo] = React.useState("");
  const [fecha, setFecha] = React.useState(new Date());
  const [dias, setDias] = React.useState(7);
  const [Imagenes, setImagenes] = React.useState([]);
  const [ImagenesEliminadas, setEliminadas] = React.useState([]);
  const [Ids, setIds] = React.useState(1);
  const [grupos, setGrupos] = React.useState([{ id: 0, descripcion: "Todos" }]);

  const compressImage = (file, archivo) => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        convertSize: 1000000,
        mimeType: file.type,
        success: (result) => {
          resolve(new File([result], archivo, { type: result.type }));
        },
        error: (error) => reject(error),
      });
    });
  };
  const HandleAceptFile = async (files) => {
    let imgs = [...Imagenes];
    let id = Ids;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      if (f.type.indexOf("video") < 0) {
        f = await compressImage(files[i], files[i].name);
      }
      let image = {
        ID: -1 * id,
        IMG: URL.createObjectURL(f), //URL.createObjectURL(files[i]),
        Ruta: files[i].name,
        Caratula: Imagenes.length > 0 ? false : true,
        SRC: f && f.type.indexOf("video") >= 0 ? "video" : "img",
        file: f, //files[i]
      };
      id++;
      imgs.push(image);
      if (imgs.length === 10) break;
    }
    setIds(id);
    setImagenes(imgs);
  };
  const BorrarImagen = (id) => {
    if (id > 0) setEliminadas([...ImagenesEliminadas, id]);
    setImagenes(Imagenes.filter((x) => x.Id !== id));
  };
  const SetCaratula = (id) => {
    Imagenes.find((x) => x.Caratula === true).Caratula = false;
    Imagenes.find((x) => x.Id === id).Caratula = true;

    setImagenes([...Imagenes]);
  };

  const UrlChange = (id, url) => {
    const dataUpdate = [...Imagenes];
    const indice = Imagenes.findIndex((x) => x.Id === id);
    const i = Imagenes.find((x) => x.Id === id);
    i.Url = url;
    dataUpdate[indice] = i;
    setImagenes([...dataUpdate]);

    //    Imagenes.find((x) => x.Id === id).Url = url;
  };
  React.useEffect(() => {
    if (!open) {
      setImagenes([]);
    } else {
      if (row) {
        setTitulo(row.Titulo);
        setFecha(new Date(row.Fecha));
        setDias(row.Vigencia);
        if (row.DirigidoA && row.DirigidoA.length > 0) setGrupos(row.DirigidoA);
        else setGrupos([{ Id: 0, Descripcion: "Todos" }]);
      } else {
        setTitulo("");
        setFecha(new Date());
        setDias(7);
        setGrupos([{ Id: 0, Descripcion: "Todos" }]);
      }
    }
  }, [open]);

  React.useEffect(() => {
    setIds(1);
    setEliminadas([]);
    if (!row) {
      setImagenes([]);
      return;
    }
    var img = [
      {
        Id: row.Id,
        IMG: row.IMG,
        Ruta: row.Ruta,
        Caratula: true,
        Src: "img",
        Url: row.Url,
        file: null,
        Titulo: row.Titulo,
      },
    ];
    row.Hijos &&
      row.Hijos.map((i) => {
        let image = {
          Id: i.Id,
          IMG: i.IMG,
          Ruta: i.Ruta,
          Caratula: false,
          Src: i.Src,
          Url: i.Url,
          file: null,
          Titulo: i.Titulo,
        };

        img.push(image);
      });

    setImagenes(img);
  }, [row]);
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      maxWidth="lg"
      fullWidth
      disableBackdropClick
      onClose={handleCloseEdit}
    >
      <DialogContent dividers style={{ overflow: "hidden" }}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={esLocale}
        >
          <Grid container spacing={2}>
            <Grid
              size={{ xs: 12, sm: 4 }}
              container
              spacing={2}
              sx={{ height: "100%" }}
            >
              <Grid size={12}>
                <TextField
                  fullWidth
                  label="Título"
                  autoFocus
                  variant="outlined"
                  value={titulo}
                  slotProps={{
                    htmlInput: {
                      maxLength: 50,
                    },
                  }}
                  onChange={(e) => setTitulo(e.target.value)}
                />
              </Grid>
              <Grid size={8}>
                <DatePicker
                  fullWidth
                  format="dd/MM/yyyy"
                  label="Fecha"
                  value={fecha}
                  onChange={(newValue) => setFecha(newValue)}
                  autoOk
                  inputVariant="outlined"
                  InputAdornmentProps={{ position: "end" }}
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  variant="outlined"
                  label="Vigencia(días)"
                  type="number"
                  fullWidth
                  slotProps={{ htmlInput: { min: 7, max: 60 } }}
                  value={dias}
                  onChange={(e) => setDias(e.target.value)}
                />
              </Grid>
              <Grid size={12}>
                <Autocomplete
                  noOptionsText="Sin opciones"
                  multiple
                  options={opcionGrupos}
                  getOptionLabel={(option) => option.Descripcion}
                  limitTags={3}
                  fullWidth
                  freeSolo
                  renderTags={(tagValue, getTagProps) => {
                    return tagValue.map((option, index) =>
                      option.Descripcion !== "Todos" ? (
                        <Chip
                          key={option.Id}
                          label={
                            option.Descripcion
                              ? option.Descripcion
                              : opcionGrupos &&
                                  opcionGrupos.find((x) => x.Id === option.Id)
                                ? opcionGrupos.find((x) => x.Id === option.Id)
                                    .Descripcion
                                : "Grupo eliminado"
                          }
                          value={option.Id}
                          color="primary"
                          {...getTagProps({ index })}
                        />
                      ) : (
                        <Chip
                          key={0}
                          color="secondary"
                          label={"Todos"}
                          value={0}
                        />
                      ),
                    );
                  }}
                  value={grupos}
                  onChange={(event, newValue) => {
                    if (newValue.length === 0)
                      setGrupos([{ Id: 0, Descripcion: "Todos" }]);
                    else {
                      setGrupos([...newValue.filter((x) => x.Id !== 0)]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Grupos" />
                  )}
                />
              </Grid>
              <Grid size={12}>
                <Stack direction="row" justifyContent="flex-end">
                  <input
                    accept={
                      Imagenes.length > 0 ? ["image/*", "video/*"] : ["image/*"]
                    }
                    id="icon-button-file"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => HandleAceptFile(e.target.files)}
                    multiple
                  />
                  <label htmlFor="icon-button-file">
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      aria-label="upload picture"
                      component="span"
                      startIcon={<Icon>add</Icon>}
                      disabled={Imagenes.length > 9}
                    >
                      {Imagenes.length > 0
                        ? "Agregar imagen o video"
                        : "Agregar imagen"}
                    </Button>
                  </label>
                </Stack>
              </Grid>
            </Grid>
            <Grid size={{ xs: 12, sm: 8 }}>
              <ImageList
                cellHeight={200}
                cols={2}
                padding={4}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  overflowY: "auto",
                  padding: theme.spacing(2),
                  margin: theme.spacing(2),
                  maxWidth: "100%",
                  width: "100%",
                  height: 600,
                  // [theme.breakpoints.down("sm")]: {
                  //   height: "100%",
                  // },
                }}
                spacing={16}
              >
                {Imagenes.map((tile) => (
                  <ImageListItem
                    key={"I" + (tile.Id || 0).toString()}
                    sx={{
                      overflow: "hidden",
                      // maxHeight: "99%",

                      maxHeight: 204,
                    }}
                  >
                    <Card
                      variant="outlined"
                      sx={{
                        overflow: "hidden",
                        margin: "1px",
                        // maxHeight: "99%",
                        borderColor:
                          tile.Caratula === true && theme.palette.primary.main,
                      }}
                    >
                      <CardMedia
                        sx={{
                          backgroundSize: "contain",
                          objectFit: "contain",
                          maxHeight: 200,
                          maxWidth: "100%",
                        }}
                        image={tile.IMG}
                        title={tile.Titulo}
                        component={tile.Src}
                        controls
                      />
                    </Card>
                    <ImageListItemBar
                      sx={{
                        marginLeft: "2px",
                        marginRight: "2px",
                        background:
                          "linear-gradient(to top, rgba(240,240,240,0.9) 0%,  rgba(240,240,240,0.7) 40%, rgba(240,240,240,0.2) 100%)",
                        "&:hover": {
                          backgroundColor: "#F0F0F0D0",
                          boxShadow: "none",
                        },
                      }}
                      actionIcon={
                        <Stack direction="row" sx={{ alignItems: "center" }}>
                          <TextField
                            value={tile.Url}
                            fullWidth
                            variant="outlined"
                            size="small"
                            label="URL"
                            onChange={(e) => UrlChange(tile.Id, e.target.value)}
                            sx={{
                              backgroundColor: "#FFFFFF1F",
                              pr: 1,
                            }}
                          />
                          {tile.Caratula === true && (
                            <Typography variant="caption" color="textSecondary">
                              Portada
                            </Typography>
                          )}
                          {tile.Src === "img" && (
                            <Checkbox
                              checked={tile.Caratula === true}
                              disableRipple
                              color="default"
                              checkedIcon={<CheckCircle color="primary" />}
                              icon={<Icon>check_circle</Icon>}
                              onClick={() => SetCaratula(tile.Id)}
                            />
                          )}
                          {tile.Caratula !== true && (
                            <IconButton
                              color="primary"
                              onClick={() => BorrarImagen(tile.Id)}
                            >
                              <Icon>delete</Icon>
                            </IconButton>
                          )}
                        </Stack>
                      }
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          </Grid>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={handleAceptEdit}
          disabled={
            titulo.length === 0 ||
            (!row && (Imagenes.length === 0 || titulo.length === 0))
          }
        >
          Aceptar
        </Button>
        <Button onClick={handleCloseEdit} color="primary">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default Difusion;
